/// <amd-module name="VSSUI/Components/Tabs/TabProviderContext" />
import * as React from "react";
import { ITabProviderContext, ITabProviderProps, IVssContributedTab } from "VSSUI/Components/Tabs/Tabs.Props";
import { Observer } from "VSSUI/Observer";

export const TabProviderContext = React.createContext<ITabProviderContext>({
    selectedId: undefined,
    tabs: [],
    commandBarItems: [],
    renderContent: undefined,
    renderFilterBar: undefined
});

export class TabProvider extends React.Component<ITabProviderProps> {
    public render() {
        return (
            <Observer selectedTabId={this.props.selectedTabId} tabs={this.props.providers}>
                {(props: { selectedTabId: string; tabs: IVssContributedTab[] }) => {
                    const { selectedTabId } = props;
                    let selectedTab: IVssContributedTab | undefined = undefined;
                    const tabs = [...props.tabs.sort((a, b) => (a.order || 100) - (b.order || 100))];

                    tabs.forEach(tab => {
                        if (tab.id === selectedTabId) {
                            selectedTab = tab;
                        }
                    });

                    if (selectedTab === undefined) {
                        selectedTab = {
                            id: selectedTabId,
                            name: undefined,
                            render: undefined
                        };
                    }

                    return (
                        <TabProviderContext.Provider
                            value={{
                                selectedId: selectedTab.id,
                                tabs: tabs,
                                commandBarItems: selectedTab.commandBarItems,
                                renderContent: selectedTab.render,
                                renderFilterBar: selectedTab.renderFilterBar
                            }}
                        >
                            {this.props.children}
                        </TabProviderContext.Provider>
                    );
                }}
            </Observer>
        );
    }
}
